import { ResponseError } from './response-error';
export class BaseResponse<T> {
    statusCode: number;
    result: T;
    errors: ResponseError;
    constructor() { }
}
